var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamblingRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2109 8.51253V11.7392C30.2109 13.8459 28.8776 15.1792 26.7709 15.1792H22.2109V5.8592C22.2109 4.3792 23.4243 3.1792 24.9043 3.1792C26.3576 3.19253 27.6909 3.7792 28.6509 4.7392C29.6109 5.71253 30.2109 7.04587 30.2109 8.51253Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54492 9.84587V28.5125C3.54492 29.6192 4.79825 30.2459 5.67825 29.5792L7.95826 27.8725C8.49159 27.4725 9.23826 27.5259 9.71826 28.0059L11.9316 30.2325C12.4516 30.7525 13.3049 30.7525 13.8249 30.2325L16.0649 27.9925C16.5316 27.5259 17.2783 27.4725 17.7983 27.8725L20.0783 29.5792C20.9583 30.2325 22.2116 29.6059 22.2116 28.5125V5.84587C22.2116 4.3792 23.4116 3.1792 24.8783 3.1792H10.2116H8.87826C4.87826 3.1792 3.54492 5.56587 3.54492 8.51253V9.84587Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23828 18.8195L16.5183 11.5396",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7775 18.5129H16.7895",
    stroke: "#2A38A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13786 11.8459H9.14983",
    stroke: "#2A38A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamblingRateIcon);
export default __webpack_public_path__ + "static/media/gamblingRateIcon.59b631824a0ffa9b0e20e9f904f3f0b8.svg";
export { ForwardRef as ReactComponent };